import React, { memo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Tag, Bell, CheckCircle2 } from 'lucide-react';
const dreamSteps = [{
  id: 1,
  title: 'Matricular em curso online',
  completed: true,
  completedDate: '10/01/2024'
}, {
  id: 2,
  title: 'Estudar 30 minutos por dia',
  completed: true,
  completedDate: '15/01/2024'
}, {
  id: 3,
  title: 'Completar módulo de gramática',
  completed: true,
  completedDate: '25/01/2024'
}, {
  id: 4,
  title: 'Praticar conversação semanalmente',
  completed: true,
  completedDate: '05/02/2024'
}, {
  id: 5,
  title: 'Assistir filmes em inglês sem legendas',
  completed: true,
  completedDate: '15/02/2024'
}, {
  id: 6,
  title: 'Ler um livro em inglês',
  completed: true,
  completedDate: '28/02/2024'
}, {
  id: 7,
  title: 'Fazer teste de proficiência',
  completed: true,
  completedDate: '10/03/2024'
}, {
  id: 8,
  title: 'Participar de grupo de conversação',
  completed: true,
  completedDate: '20/03/2024'
}, {
  id: 9,
  title: 'Fazer apresentação em inglês',
  completed: false,
  completedDate: null
}, {
  id: 10,
  title: 'Viajar para país de língua inglesa',
  completed: false,
  completedDate: null
}, {
  id: 11,
  title: 'Conseguir certificação internacional',
  completed: false,
  completedDate: null
}, {
  id: 12,
  title: 'Trabalhar em projeto internacional',
  completed: false,
  completedDate: null
}];
export function DreamDetail() {
  const {
    id
  } = useParams();
  return <div className="space-y-6" data-id="element-233">
      <Link to="/dreams" className="inline-flex items-center gap-2 text-[#2C4A6B] hover:text-[#1E3A5F] font-medium" data-id="element-234">
        <ArrowLeft className="w-4 h-4" data-id="element-235" />
        Voltar para Sonhos
      </Link>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-236">
        <div className="aspect-video w-full bg-gray-100" data-id="element-237">
          <img src="https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=800" alt="Dream" className="w-full h-full object-cover" data-id="element-238" />
        </div>
        <div className="p-6 space-y-6" data-id="element-239">
          <div data-id="element-240">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-241">
              Aprender inglês fluente
            </h1>
            <div className="flex flex-wrap items-center gap-4 mt-3" data-id="element-242">
              <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-243">
                <Tag className="w-4 h-4" data-id="element-244" />
                <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium" data-id="element-245">
                  Educação
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-246">
                <Calendar className="w-4 h-4" data-id="element-247" />
                Meta: 31/12/2024
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-248">
            <div className="space-y-6" data-id="element-249">
              <div data-id="element-250">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-251">
                  Descrição
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-252">
                  Quero alcançar fluência no inglês para expandir minhas
                  oportunidades profissionais e poder viajar com mais confiança.
                  Meu objetivo é conseguir me comunicar naturalmente em
                  situações cotidianas e profissionais.
                </p>
              </div>
              <div data-id="element-253">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-254">
                  Por que este sonho é importante
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-255">
                  O inglês é essencial para minha carreira em tecnologia.
                  Dominar o idioma me permitirá acessar mais oportunidades de
                  trabalho, participar de conferências internacionais e
                  colaborar com equipes globais. Além disso, sempre sonhei em
                  viajar para países de língua inglesa e poder me comunicar
                  livremente.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-256">
              <div data-id="element-257">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-258">
                  Como desejo comemorar
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-259">
                  Quando alcançar a fluência, vou fazer uma viagem para Londres
                  e participar de um meetup de tecnologia em inglês. Quero
                  comemorar conversando naturalmente com nativos e me sentindo
                  confiante ao fazer apresentações no idioma.
                </p>
              </div>
              <div className="bg-[#E8F4F4] rounded-lg p-6" data-id="element-260">
                <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-261">
                  Progresso do Sonho
                </h3>
                <div className="space-y-3" data-id="element-262">
                  <div className="flex items-center justify-between text-sm" data-id="element-263">
                    <span className="text-gray-600" data-id="element-264">Passos Concluídos</span>
                    <span className="font-semibold text-gray-900" data-id="element-265">8 de 12</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-266">
                    <div className="bg-gradient-to-r from-[#8BC4C3] to-[#2C4A6B] h-3 rounded-full transition-all" style={{
                    width: '67%'
                  }} data-id="element-267" />
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-268">
                    <span className="text-gray-600" data-id="element-269">Progresso Total</span>
                    <span className="font-semibold text-gray-900" data-id="element-270">67%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6" data-id="element-271">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-272">
              Passos do Sonho
            </h3>
            <div className="grid grid-cols-1 gap-4" data-id="element-273">
              {dreamSteps.map((step, index) => <div key={step.id} className="border border-gray-200 rounded-lg p-4" data-id="element-274">
                  <div className="flex items-start gap-3" data-id="element-275">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${step.completed ? 'bg-green-100' : 'bg-gray-100'}`} data-id="element-276">
                      {step.completed ? <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-277" /> : <span className="text-sm font-medium text-gray-600" data-id="element-278">
                          {index + 1}
                        </span>}
                    </div>
                    <div className="flex-1" data-id="element-279">
                      <h4 className="font-semibold text-gray-900" data-id="element-280">
                        {step.title}
                      </h4>
                      {step.completed && step.completedDate && <p className="text-xs text-gray-600 mt-1" data-id="element-281">
                          Concluído em {step.completedDate}
                        </p>}
                    </div>
                    <span className={`px-2 py-1 text-xs font-medium rounded ${step.completed ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-282">
                      {step.completed ? 'Concluído' : 'Pendente'}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6" data-id="element-283">
            <div className="flex items-center justify-between" data-id="element-284">
              <div data-id="element-285">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-286">
                  Configurações de Notificação
                </h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-287">
                  O usuário receberá lembretes sobre este sonho
                </p>
              </div>
              <button className="flex items-center gap-2 px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors" data-id="element-288">
                <Bell className="w-4 h-4" data-id="element-289" />
                Ativo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}